import React from "react";
import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import { cn } from "@/lib/utils";

export function WishlistButton({ product, className = "", size = 18 }) {
  const { has, toggle } = useWishlist();
  const active = has(product.handle);
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(product);
      }}
      aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
      aria-pressed={active}
      data-testid="product-card-wishlist-button"
      className={cn(
        "grid place-items-center rounded-full bg-white/85 backdrop-blur-sm text-ink shadow-sm transition-all duration-300 hover:scale-110",
        active ? "text-gold" : "hover:text-gold",
        className
      )}
    >
      <Heart style={{ width: size, height: size }} className={active ? "fill-gold text-gold" : ""} />
    </button>
  );
}
